export function getApiBase(): string {
  const configured = import.meta.env.VITE_API_URL;
  if (configured && configured.trim()) return configured.replace(/\/+$/, '');

  // In production we expect the API to live on a separate subdomain.
  if (import.meta.env.PROD) return 'https://api.lealchapaypintura.com';

  // In dev we rely on Vite's /api proxy.
  return '';
}
